import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { GetAccessByComposersDocument } from 'app/domains/templates';
import { AddComposerPermissionsDocument } from './AddComposerPermissions.gql';
import { RemoveComposerPermissionsDocument } from './RemoveComposerPermissions.gql';
export function useUpdateComposerPermissions() {
    const [add, addStates] = useMutation(AddComposerPermissionsDocument);
    const { addToast } = useToast();
    const [remove, removeStates] = useMutation(RemoveComposerPermissionsDocument);
    const update = { add, remove };
    const loading = addStates.loading || removeStates.loading;
    const [refetching, setRefetching] = useState(false);
    const updateComposerPermissions = (options) => {
        const { type, userIds, composerIds } = options;
        update[type]({
            variables: { userIds, composerIds },
            refetchQueries: [GetAccessByComposersDocument],
            onQueryUpdated: (query) => {
                setRefetching(true);
                return query.refetch().finally(() => setRefetching(false));
            },
            onError: () => {
                addToast({
                    title: t({
                        message: 'Something went wrong',
                        comment: 'toast when failing to update composer access',
                    }),
                    appearance: 'danger',
                });
            },
            onCompleted: () => {
                addToast({
                    title: t({
                        message: 'Updated template access successfully',
                        comment: 'success toast when updating composer access',
                    }),
                    appearance: 'success',
                });
            },
        });
    };
    return { updateComposerPermissions, loading, refetching };
}
